/* ClassyTea collection page, Wave 4 (2026-09-24). Pairs with sections/ct-collection.liquid.
   - Show more: reveals 20 at a time; "Showing X of Y" + progress bar follow.
   - Sold last: the section renders in-stock first, then sold (up to 250 a page). Pages 2+ are fetched in the background
     and merged so the order holds across the whole collection.
   - Review banners (2026-09-27): the first after row 3 (9 cards on 3 columns, 6 on phone's 2), then one every 4 rows,
     each a different review, only inside the pieces already shown. Spare banners stay hidden.
   - Filters/sort: Shopify's own params, re-rendered through the Section Rendering API, URL kept in sync.
   - Sticky bar: follows the theme's header as it hides on scroll down / shows on scroll up.
   - Add to cart: the theme's own <product-form> does the work (cart drawer updates); we only flip the label to "ADDED ✓". */
(function () {
  'use strict';
  var STEP = 20;
  var phoneMQ = window.matchMedia('(max-width: 767px)');
  var deskMQ = window.matchMedia('(min-width: 1024px)');

  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function init(coll) {
    if (coll.__ct) return; coll.__ct = true;
    var sid = coll.getAttribute('data-section');
    /* Gauntlet 2026-09-27 C-F2: vendor/type pages (/collections/vendors?q=X) carry q in their URL; keep the path as base and q separately. */
    var base = (coll.getAttribute('data-url') || location.pathname).split('?')[0];
    var Q0 = new URLSearchParams(location.search).get('q');
    /* Gauntlet 2026-09-27 C-F1: an old ?page=N link would show an empty grid (this page loads every page itself). Drop page and reload. */
    var sp0 = new URLSearchParams(location.search);
    if (sp0.has('page') && sp0.get('page') !== '1') { sp0.delete('page'); location.replace(location.pathname + (sp0.toString() ? '?' + sp0.toString() : '') + location.hash); return; }
    var lastSearch = location.search;
    var root = coll.querySelector('[data-ct-root]');
    var shown = STEP;
    var closedGroups = {};
    var loading = null;      // promise for background pages
    var reqId = 0;

    function grid() { return root.querySelector('[data-ct-grid]'); }
    function bands() { var g = grid(); return g ? qsa(g, '[data-ct-band]') : []; }
    function cards() { var g = grid(); return g ? qsa(g, '[data-ct-card]') : []; }
    function total() { var g = grid(); return g ? parseInt(g.getAttribute('data-total'), 10) || 0 : 0; }
    function cols() { return phoneMQ.matches ? 2 : 3; }

    /* ---------- grid: order, reveal, banner, counters ---------- */
    function sortSoldLast() {
      var g = grid(); if (!g) return;
      var all = cards();
      var avail = all.filter(function (c) { return c.getAttribute('data-sold') !== 'true'; });
      var sold = all.filter(function (c) { return c.getAttribute('data-sold') === 'true'; });
      var ordered = avail.concat(sold);
      var same = ordered.every(function (c, i) { return c === all[i]; });
      if (!same) ordered.forEach(function (c) { g.appendChild(c); });
    }
    function layout() {
      var g = grid(); if (!g) return;
      var list = cards();
      var n = Math.min(shown, list.length);
      list.forEach(function (c, i) { if (i < n) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
      /* S, 2026-09-25: a banner shows on every page (after the last shown piece when there are fewer than 3 rows).
         S, 2026-09-27: then a new one every 4 rows, never the same review twice. 15:53 same day: every 5 rows (4 was too frequent). */
      var bs = bands(), first = cols() * 3, every = cols() * 5;
      bs.forEach(function (b, k) {
        var pos = first + k * every;             // cards before this banner
        var ref = null;
        if (pos < n) ref = list[pos - 1];         // there are shown pieces below it
        else if (k === 0 && n > 0) ref = list[n - 1];
        if (ref) {
          b.removeAttribute('hidden');
          if (ref.nextElementSibling !== b) ref.after(b);
        } else {
          b.setAttribute('hidden', '');
        }
      });
      var t = total();
      var vis = Math.min(n, t);
      qsa(root, '[data-ct-shown]').forEach(function (s) { s.textContent = vis; });
      var bar = root.querySelector('[data-ct-bar]');
      if (bar && t) bar.style.width = (vis / t * 100).toFixed(1) + '%';
      var more = root.querySelector('[data-ct-more]');
      if (more) { if (vis >= t) more.setAttribute('hidden', ''); else more.removeAttribute('hidden'); }
    }

    function pageUrl(page) {
      var p = new URLSearchParams(location.search);
      p.delete('page'); p.delete('section_id');
      if (page > 1) p.set('page', page);
      p.set('section_id', sid);
      return base + '?' + p.toString();
    }
    function loadRest() {
      var g = grid(); if (!g) return Promise.resolve();
      var pages = parseInt(g.getAttribute('data-pages'), 10) || 1;
      if (pages < 2 || g.__loaded) return Promise.resolve();
      /* Gauntlet 2026-09-27 C-F3: the in-flight load belongs to its grid; a new grid (sort/filter) starts its own. */
      if (g.__loading) return g.__loading;
      var myReq = reqId;
      var jobs = [];
      for (var p = 2; p <= pages; p++) jobs.push(fetch(pageUrl(p), { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
      loading = Promise.all(jobs).then(function (htmls) {
        if (myReq !== reqId || grid() !== g) return;
        var seen = {};
        cards().forEach(function (c) { seen[c.getAttribute('data-variant')] = 1; });
        htmls.forEach(function (h) {
          var doc = new DOMParser().parseFromString(h, 'text/html');
          qsa(doc, '[data-ct-grid] [data-ct-card]').forEach(function (c) {
            var v = c.getAttribute('data-variant');
            if (seen[v]) return; seen[v] = 1;
            c.setAttribute('hidden', '');
            g.appendChild(document.adoptNode(c));
          });
        });
        g.__loaded = true;
        sortSoldLast();
        layout();
      }).catch(function () {}).then(function () { g.__loading = null; });
      g.__loading = loading;
      return loading;
    }

    /* S 2026-09-27: remember how far "Show more" went (and the scroll spot) in this history entry, so Back returns there. */
    function saveSpot() {
      try { history.replaceState(Object.assign({}, history.state || {}, { ctShown: shown, ctY: Math.round(window.scrollY) }), ''); } catch (e) {}
    }
    window.addEventListener('pagehide', saveSpot);
    function onMore(btn) {
      shown += STEP;
      saveSpot();
      if (cards().length < shown) {
        btn.classList.add('is-loading');
        loadRest().then(function () { btn.classList.remove('is-loading'); layout(); });
      }
      layout();
    }

    /* ---------- filters + sort ---------- */
    function form() { return root.querySelector('[data-ct-form]'); }
    function queryFromForm() {
      var f = form(); var p = new URLSearchParams();
      if (!f) return p;
      var fd = new FormData(f);
      var priceBox = f.querySelector('[data-ct-price]');
      var pmax = priceBox ? parseFloat(priceBox.getAttribute('data-max')) : null;
      fd.forEach(function (v, k) {
        v = String(v).trim();
        if (/price\.(gte|lte)$/.test(k)) {
          v = v.replace(/[^0-9.]/g, '');
          if (v === '') return;
          var num = parseFloat(v);
          if (/gte$/.test(k) && num <= 0) return;
          if (/lte$/.test(k) && pmax !== null && num >= pmax) return;
        }
        if (v === '') return;
        p.append(k, v);
      });
      var sel = root.querySelector('[data-ct-sort]');
      if (sel && !p.has('sort_by')) p.set('sort_by', sel.value);
      return p;
    }
    function applyQuery(qs, push) {
      if (Q0) { var qp = new URLSearchParams(qs || ''); if (!qp.has('q')) { qp.set('q', Q0); qs = qp.toString(); } }
      var my = ++reqId;
      coll.classList.add('is-busy');
      var url = base + (qs ? '?' + qs : '');
      var fetchUrl = base + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(sid);
      return fetch(fetchUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
        if (my !== reqId) return;
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var fresh = doc.querySelector('[data-ct-root]');
        if (!fresh) { location.href = url; return; }
        swap(fresh);
        /* S 2026-09-27: the "for sale · sold" counts above the title follow the filters too. */
        var fe = doc.querySelector('[data-ct-eyebrow]'), me = coll.querySelector('[data-ct-eyebrow]');
        if (me) { if (fe) { me.textContent = fe.textContent; me.hidden = false; } else me.hidden = true; }
        if (push) history.pushState({ ct: 1 }, '', url); else history.replaceState({ ct: 1 }, '', url);
        lastSearch = location.search;
        shown = STEP;
        sortSoldLast(); layout(); loadRest();
      }).catch(function () { location.href = url; }).then(function () { if (my === reqId) coll.classList.remove('is-busy'); });
    }
    function swap(fresh) {
      var active = document.activeElement;
      var keepGroup = active && active.closest ? active.closest('[data-ct-group]') : null;
      // toolbar, results, drawer button: replace outright
      ['[data-ct-toolbar]', '.ct-coll__results', '.ct-coll__show'].forEach(function (s) {
        var a = root.querySelector(s), b = fresh.querySelector(s);
        if (a && b) a.replaceWith(document.adoptNode(b));
      });
      // filter groups: replace each, except the one being typed in
      var f = form(), nf = fresh.querySelector('[data-ct-form]');
      if (f && nf) {
        var old = {}; qsa(f, '[data-ct-group]').forEach(function (g) { old[g.getAttribute('data-ct-group')] = g; });
        var frag = [];
        qsa(nf, '[data-ct-group]').forEach(function (g) {
          var k = g.getAttribute('data-ct-group');
          frag.push(keepGroup && old[k] === keepGroup ? keepGroup : document.adoptNode(g));
        });
        qsa(f, '[data-ct-group]').forEach(function (g) { if (frag.indexOf(g) < 0) g.remove(); });
        var line = f.querySelector('.ct-f__close-line');
        frag.forEach(function (g) { f.insertBefore(g, line); });
      }
      applyGroupState(); applySideLabel();
    }
    var tmr = null;
    function onFormChange(e, delay) {
      clearTimeout(tmr);
      tmr = setTimeout(function () { applyQuery(queryFromForm().toString(), true); }, delay || 0);
    }

    /* ---------- panel: sidebar / drawer / groups ---------- */
    function applyGroupState() {
      qsa(root, '[data-ct-group]').forEach(function (g) {
        var k = g.getAttribute('data-ct-group');
        var closed = !!closedGroups[k];
        g.classList.toggle('is-closed', closed);
        var b = g.querySelector('[data-ct-group-toggle]'); if (b) b.setAttribute('aria-expanded', closed ? 'false' : 'true');
      });
    }
    function applySideLabel() {
      var closed = coll.classList.contains('is-side-closed');
      qsa(root, '[data-ct-side-label]').forEach(function (s) { s.textContent = closed ? 'Show filters' : 'Hide filters'; });
      qsa(root, '[data-ct-side-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', closed ? 'false' : 'true'); });
    }
    function drawer(open) {
      coll.classList.toggle('is-drawer', open);
      document.documentElement.classList.toggle('ct-lock', open);
      qsa(root, '[data-ct-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var c = root.querySelector('[data-ct-panel] [data-ct-drawer-close]'); if (c) c.focus({ preventScroll: true }); }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if ((el = t.closest('[data-ct-more]'))) { onMore(el); return; }
      if ((el = t.closest('[data-ct-side-toggle]'))) { coll.classList.toggle('is-side-closed'); applySideLabel(); return; }
      if ((el = t.closest('[data-ct-drawer-open]'))) { drawer(true); return; }
      if ((el = t.closest('[data-ct-drawer-close]'))) { drawer(false); return; }
      if ((el = t.closest('[data-ct-group-toggle]'))) {
        var g = el.closest('[data-ct-group]'); var k = g.getAttribute('data-ct-group');
        closedGroups[k] = !closedGroups[k]; applyGroupState(); return;
      }
      if ((el = t.closest('[data-ct-clear]'))) {
        e.preventDefault();
        var u = new URL(el.href, location.href);
        applyQuery(u.searchParams.toString(), true);
      }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ct-sort]')) { onFormChange(e, 0); return; }
      if (t.closest('[data-ct-form]')) onFormChange(e, t.type === 'checkbox' ? 0 : 400);
    });
    root.addEventListener('input', function (e) {
      if (e.target.closest('[data-ct-price]')) onFormChange(e, 900);
    });
    root.addEventListener('submit', function (e) {
      if (e.target.matches('[data-ct-form]')) { e.preventDefault(); onFormChange(e, 0); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && coll.classList.contains('is-drawer')) drawer(false); });
    /* Gauntlet 2026-09-27 C-F10: Safari 13 and older have no MediaQueryList.addEventListener. */
    var onDesk = function () { if (deskMQ.matches) drawer(false); };
    if (deskMQ.addEventListener) deskMQ.addEventListener('change', onDesk); else if (deskMQ.addListener) deskMQ.addListener(onDesk);
    /* Gauntlet 2026-09-27 C-F4: a hash-only change (e.g. "Skip to content") must not re-query and reset "Show more". */
    window.addEventListener('popstate', function () { if (location.search === lastSearch) return; lastSearch = location.search; applyQuery(location.search.replace(/^\?/, ''), false); });

    /* ---------- add to cart feedback ---------- */
    document.addEventListener('cart:update', function (e) {
      var id = e.detail && e.detail.productVariantId;
      if (!id) return;
      qsa(root, '.ct-atc input[name="id"][value="' + String(id) + '"]').forEach(function (inp) {
        var btn = inp.form && inp.form.querySelector('.ct-atc__btn');
        if (!btn) return;
        btn.classList.add('is-added');
        var l = btn.querySelector('.ct-atc__label'); if (l) l.textContent = 'ADDED ✓';
      });
    });

    /* Audit 2026-09-26 #10: when the cart changes (drawer or /cart), put "ADDED" cards whose piece left the cart back to ADD TO CART. */
    function resyncAdded() {
      if (!root.querySelector('.ct-atc__btn.is-added')) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !Array.isArray(c.items)) return;
          var ids = c.items.map(function (i) { return String(i.variant_id); });
          qsa(root, '.ct-atc__btn.is-added').forEach(function (btn) {
            var inp = btn.form && btn.form.querySelector('input[name="id"]');
            if (!inp || ids.indexOf(String(inp.value)) !== -1) return;
            btn.classList.remove('is-added');
            var l = btn.querySelector('.ct-atc__label'); if (l) l.textContent = 'ADD TO CART';
          });
        }).catch(function () {});
    }
    document.addEventListener('atc:updated', resyncAdded);
    document.addEventListener('cart:updated', resyncAdded);
    window.addEventListener('pageshow', function (e) { if (e.persisted) resyncAdded(); });

    /* ---------- sticky bar follows the theme header ---------- */
    var stickEls = null, raf = 0;
    function findStick() {
      stickEls = qsa(document, '.announcement-bar-section, header-menu').filter(function (el) { return !coll.contains(el); });
    }
    function measure() {
      raf = 0;
      if (!stickEls) findStick();
      var top = 0;
      stickEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > top && r.top < 400) {
          var pos = getComputedStyle(el).position;
          var parentPos = el.parentElement ? getComputedStyle(el.parentElement).position : '';
          if (pos === 'sticky' || pos === 'fixed' || parentPos === 'sticky' || parentPos === 'fixed' || r.top >= -1) top = Math.max(top, r.bottom);
        }
      });
      coll.style.setProperty('--ct-stick', Math.max(0, Math.round(top)) + 'px');
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(measure); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { stickEls = null; onScroll(); });
    document.addEventListener('transitionend', function (e) { if (e.target && e.target.closest && e.target.closest('header-menu, .header-section')) onScroll(); }, true);

    var lastCols = cols();
    window.addEventListener('resize', function () { var c = cols(); if (c !== lastCols) { lastCols = c; layout(); } });

    sortSoldLast(); layout(); measure();
    var back = history.state && history.state.ctShown > STEP ? history.state : null;
    if (back) {
      shown = back.ctShown;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var goBack = function () { layout(); window.scrollTo(0, back.ctY || 0); };
      if (cards().length < shown) loadRest().then(goBack); else goBack();
    }
    if ('requestIdleCallback' in window) requestIdleCallback(function () { loadRest(); }, { timeout: 2500 });
    else setTimeout(loadRest, 1200);
  }

  function boot() { qsa(document, '[data-ct-coll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
